import { Box, Divider, Skeleton } from '@factorialco/deprecated-design-system'

import { MessageListSkeleton } from 'modules/ats/components/MessageBoard/MessageList/MessageListSkeleton'

export const MessageInboxConversationViewSkeleton = () => {
  return (
    <Box maxHeight="full" width="full" gap="s12">
      <Box>
        <Box
          width="full"
          flexDirection="row"
          paddingX="s32"
          paddingBottom="s16"
          alignItems="center"
          gap="s8"
          justifyContent="spaceBetween"
        >
          <Box flexGrow flexDirection="row" gap="s16">
            <Skeleton width="s120" height="s24" />
            <Skeleton width="s48" height="s24" />
          </Box>
          <Skeleton width="s140" height="s32" />
          <Skeleton width="s24" height="s24" />
        </Box>
        <Divider />
      </Box>

      <Box paddingX="s24">
        <MessageListSkeleton messagesPerGroup={4} />
      </Box>
    </Box>
  )
}
